import { Map } from 'immutable';

import { aiGenerated } from './ai';

import { FIND, OPERATIONS, REPLACE } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { VALUE } from '../../../../constants/product';

export function description({ channel, operation, preview, state }) {
  switch (operation) {
    case OPERATIONS[channel].DESCRIPTION.AI_GENERATED: {
      return aiGenerated({ attribute: ATTRIBUTE.DESCRIPTION, channel, preview, state });
    }

    case OPERATIONS[channel].DESCRIPTION.FIND_AND_REPLACE: {
      return {
        payload: Map({
          type: operation,
          value: Map({
            find: preview.getIn([ATTRIBUTE.DESCRIPTION, FIND]),
            replace: preview.getIn([ATTRIBUTE.DESCRIPTION, REPLACE]),
          }),
        }),
      };
    }

    default: {
      return {
        payload: Map({
          type: operation,
          value: preview.getIn([ATTRIBUTE.DESCRIPTION, VALUE]),
        }),
      };
    }
  }
}
